import { sanitizeId } from '~/portal/utils/shared/content'

export const getMethodDisplayName = (method: string) => {
  const methodNames: Record<string, string> = {
    get: 'GET',
    post: 'POST',
    put: 'PUT',
    delete: 'DELETE',
    patch: 'PATCH',
    sub: 'SUBSCRIBE',
    pub: 'PUBLISH',
    rec: 'RECEIVE',
    send: 'SEND',
    query: 'QUERY',
    message: 'MESSAGE',
  }
  return methodNames[method.toLowerCase()] || method.toUpperCase()
}

export const buildBreadcrumbsData = ({ productName, tileKey, parents = [], title, excludeLastItem = false }: { productName: string, tileKey: string, parents?: string[], title: string, excludeLastItem?: boolean }) => {
  const product = {
    title: productName, id: sanitizeId(`product-${productName}-${tileKey}`)
  }
  const parentsArr = parents.map(parent => ({ title: parent, id: sanitizeId(`parent-${parent}-${tileKey}`) }))
  const page = { title: title, id: sanitizeId(`page-${title}-${tileKey}`) }
  
  if (excludeLastItem) {
    return [
      product,
      ...parentsArr
    ]
  }
  
  return [
    product,
    ...parentsArr,
    page
  ]
}